import {
  LocalDate,
  SessionStorageUtils,
} from '@brunommsilva/react-foundations';

import { FilterFields, TransactionsFilter } from './filter';

// In the storage the days of the filter are plain YYYY-MM-DD strings.
type SavedFilter = {
  dateFrom?: string;
  dateTo?: string;
  type?: FilterFields['type'];
  category?: FilterFields['category'];
  account?: FilterFields['account'];
  description?: FilterFields['description'];
};

class TransactionsFilterStorage {
  private readonly KEY = 'transactions_filter';

  public get(): TransactionsFilter {
    const saved = SessionStorageUtils.getItem<SavedFilter>(this.KEY);

    if (!saved) {
      return new TransactionsFilter();
    }

    return new TransactionsFilter({
      ...saved,
      dateFrom: saved.dateFrom ? new LocalDate(saved.dateFrom) : undefined,
      dateTo: saved.dateTo ? new LocalDate(saved.dateTo) : undefined,
    });
  }

  public set(filter: TransactionsFilter): void {
    SessionStorageUtils.setItem(this.KEY, filter);
  }

  public clear(): void {
    SessionStorageUtils.removeItem(this.KEY);
  }
}

const transactionsFilterStorage = new TransactionsFilterStorage();
export default transactionsFilterStorage;
